import { render, staticRenderFns } from "./AccessibilityStatement.vue?vue&type=template&id=531acbbc&scoped=true"
import script from "./AccessibilityStatement.vue?vue&type=script&lang=js"
export * from "./AccessibilityStatement.vue?vue&type=script&lang=js"
import style0 from "./AccessibilityStatement.vue?vue&type=style&index=0&id=531acbbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531acbbc",
  null
  
)

export default component.exports